// TeamRow.js
import React from 'react';
import PlayerIdentity from '../../shared/PlayerIdentity';
import injuryIcon from '../../shared/assets/hospital.png';
import MarketValueCell from './MarketValueCell';

const IRPlayerRow = ({ player }) => {

    return (
      <tr>
        <td className="name-td">
          <div className="flex-container">
            <PlayerIdentity player={player} icon={injuryIcon} />
          </div>
        </td>       

        <td>{player.salary}</td>
        <MarketValueCell value={player.auction_value} />
        <td>{player.contract_length}</td>
        <td>{player.salary_relief}</td>
        <td>{player.contract_relief}</td>

      </tr>
    );
  };
  
  export default IRPlayerRow;
